<template>
  <div
    class="tw-rounded-2xl tw-bg-white dark:tw-bg-slate-800 tw-border tw-border-slate-100 dark:tw-border-slate-700 tw-shadow tw-py-3.5 tw-px-4 tw-flex tw-flex-col tw-gap-3"
  >
    <div
      class="tw-text-sm tw-text-slate-700 dark:tw-text-slate-50 tw-font-geist tw-font-medium"
    >
      Breakdown by Device
    </div>
    <div class="tw-relative">
      <div>
        <pie-chart
          :data="chartData"
          :dataset="{
            cutout: '70%',
            borderWidth: 0,
            radius: '90%',
          }"
          height="220px"
          :colors="chartColors"
          :donut="true"
          legend="top"
          suffix="%"
        />
      </div>
      <LoaderSm v-if="props.loading" />
    </div>
  </div>
</template>

<script setup>
import LoaderSm from "@/components/LoaderSm.vue";
import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();
const props = defineProps(["data", "loading"]);

const total = computed(() => {
  return props.data.reduce((sum, item) => sum + Number(item.count), 0);
});

const chartData = computed(() => {
  return props.data.map((item) => [
    item.device_type.charAt(0).toUpperCase() + item.device_type.slice(1),
    Number(((Number(item.count) / total.value) * 100).toFixed(1)),
  ]);
});

const chartColors = computed(() => {
  return store.getters.currentTheme == "dark"
    ? ["#008236", "#00c951", "#7bf1a8", "#dbfce7"]
    : ["#7008e7", "#8e51ff", "#c4b4ff", "#ede9fe"];
});
</script>
